import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useNavState } from '@/common/navState/NavStateContext';
import { ValList } from '@/common/val/ValList';
import { CalcProdPpList } from '@/gp/entities/calc/calcProdPp/CalcProdPpList';
import { CalcProdResList } from '@/gp/entities/calcProdRes/CalcProdResList';

/**
 * Per requirement GP-10, this provides a detailed view of a calculation product
 **/
export const CalcProdDetail = () => {
  const { navState } = useNavState();
  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'resTab', label: 'Results', content: <CalcProdResList calcProdObj={entityObj} calc={navState.calc} /> },
    { id: 'ppTab', label: 'Price Points', disabled: navState.calc.polType !== 'BP', content: <CalcProdPpList calcProd={entityObj} calc={navState.calc} /> },
    { id: 'valTab', label: 'Validations', content: <ValList parentEntity="CALC_PROD" parentEntityId={entityObj.id} /> },
  ]

  return (
    <EntityDetail tabSpecs={tabSpecs}/>
  )
}